import CreateNewDataRoomModal from './CreateNewDataRoomModal.component';

export default CreateNewDataRoomModal;
